import React, { useState, useEffect } from "react";
import Icon from "@insight/toolkit-react/lib/Icon/Icon";
import { isMobile, throttle } from '@insight/toolkit-utils';

export default function NiaLink({ setIsOpen }) {
  const [isOnMobile, setIsMobile] = useState(isMobile())

  useEffect(() => {
    const onResize = throttle(() => {
      setIsMobile(isMobile())
    }, 250)
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  function handleClick() {
    setIsOpen(true);
  }

  return (
    <li className="o-list-inline__item  c-header-simple-nav__item">
        <a onClick={handleClick} className="c-button">
            {isOnMobile ?
                <Icon icon="NIA-mobile" /> :
                <div className="c-header-main-nav__item-nia"><Icon icon="NIA" />Nia <Icon icon="new" /></div>
            }
        </a>
    </li>
  );
}
